import React from "react";

import "./style.scss";

const UIButton = ({ text, onClick, size = "", variant = "primary" }) => {
  return (
    <button className={`ui-button ${variant} size-${size}`} onClick={onClick}>
      {text}
    </button>
  );
};

export default UIButton;
